import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Public routes redirect authenticated users. If onboarding is incomplete they
 * go to /onboarding; otherwise /dashboard. /2fa is unguarded (has its own logic).
 */
const PublicOnlyRoute = ({ children }) => {
  const { isAuthenticated, booting, user } = useAuth();
  const location = useLocation();
  if (booting) return null;
  if (isAuthenticated && location.pathname !== "/2fa") {
    if (user?.is_admin) return <Navigate to="/admin" replace />;
    if (user && user.onboarding_completed === false) {
      return <Navigate to="/onboarding" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export default PublicOnlyRoute;
